import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

export const userManager = new UserManager({
  authority: import.meta.env.VITE_AUTHORITY,
  // biome-ignore lint/style/useNamingConvention: Expected
  client_id: import.meta.env.VITE_CLIENT_ID,
  // biome-ignore lint/style/useNamingConvention: Expected
  redirect_uri: `${window.location.origin}/auth/callback/meshify`,
  // biome-ignore lint/style/useNamingConvention: Expected
  post_logout_redirect_uri: `${window.location.origin}/login`,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  monitorSession: true, // this allows cross tab login/logout detection
  automaticSilentRenew: true,
  scope: 'openid profile email offline_access',
})

// Handle session monitoring events
userManager.events.addUserSignedOut(() => {
  // Store current location for redirect after re-login
  const currentLocation = window.location.pathname + window.location.search + window.location.hash
  if (!currentLocation.includes('/login')) {
    sessionStorage.setItem('redirectAfterLogin', currentLocation)
  }

  // Let the AuthProvider handle the actual logout process
  window.dispatchEvent(new CustomEvent('oidc-session-expired'))
})

userManager.events.addSilentRenewError((error) => {
  // This could indicate session expiration
  window.dispatchEvent(new CustomEvent('oidc-silent-renew-error', { detail: error }))
})

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, '/')
}
